export function SuccessCheckIcon({ className = 'h-20 w-20' }) {
  return (
    <svg className={className} viewBox="0 0 80 80" fill="none" aria-hidden>
      <circle cx="40" cy="40" r="40" fill="#8B68DD" />
      <path
        d="M24 41.5L34.5 52L56 30"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ErrorWarnIcon({ className = 'h-4 w-4' }) {
  return (
    <svg className={className} viewBox="0 0 16 16" fill="none" aria-hidden>
      <path
        d="M7.13 2.6c.38-.7 1.36-.7 1.74 0l5.6 10.2c.37.68-.12 1.5-.87 1.5H2.4c-.75 0-1.24-.82-.87-1.5l5.6-10.2z"
        fill="#F6475F"
      />
      <path d="M8 6v3.2" stroke="white" strokeWidth="1.4" strokeLinecap="round" />
      <circle cx="8" cy="11.2" r="0.8" fill="white" />
    </svg>
  );
}

export function UserBadgeIcon({ className = 'h-[42px] w-[42px]' }) {
  return (
    <svg className={className} viewBox="0 0 42 42" fill="none" aria-hidden>
      <circle cx="21" cy="21" r="21" fill="#F0ECFF" />
      <circle cx="21" cy="16" r="6" fill="#8B68DD" />
      <path
        d="M10 32c0-5.5 4.5-9 11-9s11 3.5 11 9"
        stroke="#8B68DD"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function PhoneBadgeIcon({ className = 'h-[46px] w-[30px]' }) {
  return (
    <svg className={className} viewBox="0 0 30 46" fill="none" aria-hidden>
      <rect x="2" y="1" width="26" height="44" rx="5" stroke="#8B68DD" strokeWidth="2.5" />
      <path d="M12 38h6" stroke="#8B68DD" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="15" cy="8" r="1.2" fill="#8B68DD" />
    </svg>
  );
}

export function NetworkErrorIcon({ className = 'h-[42px] w-[42px]' }) {
  return (
    <svg className={className} viewBox="0 0 42 42" fill="none" aria-hidden>
      <circle cx="21" cy="21" r="21" fill="#F0ECFF" />
      <path
        d="M14 28c2.5-3 5.2-4.5 7-4.5s4.5 1.5 7 4.5"
        stroke="#8B68DD"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path
        d="M16.5 24c1.8-2 3.4-3 4.5-3s2.7 1 4.5 3"
        stroke="#8B68DD"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <circle cx="21" cy="17" r="2" fill="#8B68DD" />
    </svg>
  );
}

export function HintCheckIcon({ className = 'h-2 w-2.5' }) {
  return (
    <svg className={className} viewBox="0 0 10 8" fill="none" aria-hidden>
      <path
        d="M1 4L3.5 6.5L9 1"
        stroke="#8B68DD"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
